<template>
  <div>
    <trainDetail/>
  </div>
</template>
<script>
import trainDetail from '@/components/public/trainDetail';

export default {
  components:{
    trainDetail
  },
  mounted() {
      this.$emit("goRouter", "/shanxi/train/");
  },
  
}
</script>